import React, { Component } from "react";
import Hero from "../components/Hero";
import RecipesList from "../components/RecipesList";

const apiKey = process.env.REACT_APP_API;

export default class Home extends Component {
  state = {
    recipes: [],
  };

  componentDidMount() {
    const apiUrl = `https://api.spoonacular.com/recipes/random?number=18&apiKey=${apiKey}`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          recipes: data.recipes,
        });
      });
  }

  render() {
    const { recipes } = this.state;
    return (
      <div>
        <Hero />
        <h1 className="home">Random Recipes</h1>
        <RecipesList recipes={recipes} />
      </div>
    );
  }
}
